import React, { FC, memo } from "react";
import { Typography } from "@material-ui/core";
import { Remove as Dash } from "@material-ui/icons";
import { RouteOfAdministration } from "../../typescript/interfaces/data";

type RouteTDProps = {
  routesOfAdministration: RouteOfAdministration[];
};

const RouteTD: FC<RouteTDProps> = memo(({ routesOfAdministration }) => {
  if (routesOfAdministration.length === 0) return <Dash fontSize="small" />;

  return (
    <>
      {routesOfAdministration.map(({ id, name }) => (
        <Typography variant="body2" key={id}>
          {name}
        </Typography>
      ))}
    </>
  );
});

export default RouteTD;
